import { createFileRoute } from '@tanstack/react-router';

import { buildBreadcrumbSchema, buildSeoHead, buildWebPageSchema, jsonLdScript, ROUTE_META } from '@src/corelib/seo';

export const Route = createFileRoute('/platform/business')({
  head: () => ({
    ...buildSeoHead({ path: '/platform/business', ...ROUTE_META['/platform/business'] }),
    scripts: [
      jsonLdScript(buildBreadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Business', path: '/platform/business' }])),
      jsonLdScript(buildWebPageSchema({ path: '/platform/business', ...ROUTE_META['/platform/business'] })),
    ],
  }),
});
